module.exports = __webpack_public_path__ + "img/pepco-trip-scene.af959ec5.jpeg";